export default __webpack_public_path__ + "static/media/livespotting.a4a3b5b3.svg";